import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 31,
	viewBox: "0 0 20 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.72837 0.979838C8.61428 0.806879 8.5704 0.595004 8.62744 0.396101C8.65816 0.231789 8.78102 0.132338 8.92582 0.076126C8.97847 0.0545061 9.03113 0.0372101 9.08817 0.0285621C9.10133 0.0242382 9.11011 0.0242382 9.12327 0.0242382C9.40848 -0.0276496 9.70686 0.0199143 9.70686 0.0199143C12.0588 0.279353 16.6309 0.785259 18.114 0.94957C18.9038 1.03605 19.2548 1.4598 19.2856 2.08245C19.2812 2.22514 19.2548 2.38513 19.1934 2.56674C18.8819 3.52234 17.8639 6.66587 17.2101 8.69815C16.9029 9.6278 16.5826 10.5834 16.451 10.9207C16.451 10.9207 16.451 10.9207 16.451 10.925C16.3764 11.0547 16.2755 11.1931 16.1526 11.2666C16.1482 11.2666 16.1482 11.2709 16.1438 11.2709C16.0912 11.3012 16.0342 11.3228 15.9771 11.3271C15.9727 11.3271 15.9727 11.3271 15.9683 11.3271C15.7051 11.3574 15.4681 11.2061 15.3277 10.9985C15.3277 10.9985 15.1083 10.6612 14.8933 10.3413C14.6827 10.0213 14.2527 9.92616 13.9236 10.1251C13.1162 10.618 11.756 11.4439 11.6682 11.4958L10.8828 12.006C10.874 12.0017 10.8653 11.9973 10.8565 11.993C9.23736 11.2277 7.61824 10.471 5.98156 9.73158C5.70952 9.61483 5.44625 9.47646 5.19175 9.3208C3.85345 8.46033 3.62528 6.53183 4.70031 5.373L5.49451 4.91466L8.99602 2.56674C9.29001 2.36784 9.37338 1.97435 9.18031 1.676L8.72837 0.979838Z",
			fill: "url(#paint0_linear_14740_2858)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2315 19.6032C18.2359 21.9036 17.0775 24.0526 15.1469 25.3411C15.1118 25.3671 15.0767 25.3887 15.0416 25.4103L13.225 26.5908L13.1153 26.6686L13.2031 26.5C14.4361 24.1218 14.4053 22.9024 11.3163 21.4625L7.4813 19.6767L4.98461 18.5136C4.76082 18.4271 4.54143 18.3276 4.32643 18.2195C4.25183 18.185 4.18163 18.146 4.10703 18.1071C1.79902 16.9699 0 14.6696 0 11.9541C0 9.93912 0.728384 8.11008 2.43965 6.85612L4.29571 5.63676L4.73889 5.35138C4.62919 5.47245 4.52827 5.60217 4.4449 5.74054C4.37469 5.84864 4.31765 5.96538 4.265 6.08646C4.23867 6.15132 4.21234 6.21185 4.1904 6.27671C4.13775 6.43238 4.09826 6.58804 4.07632 6.75235C4.05877 6.87342 4.04999 6.99882 4.04999 7.11989C4.04999 7.50905 4.13775 7.89388 4.30449 8.24845C4.50633 8.67652 4.82225 9.04406 5.22155 9.3035C5.47605 9.45916 5.73932 9.5932 6.01136 9.71428C6.49842 9.9175 6.9723 10.1553 7.45058 10.3758C7.92886 10.5964 8.39397 10.7996 8.86347 11.0201C9.5392 11.3358 10.2105 11.6601 10.8863 11.9757C10.895 11.98 10.9038 11.9844 10.9126 11.9887L11.0091 12.0319L11.7507 12.3778L12.444 12.7021L13.0583 12.9875L13.5673 13.2253L13.949 13.4026L14.1772 13.5064L14.2298 13.5324H14.2342C16.5554 14.6566 18.2315 16.8834 18.2315 19.6032Z",
			fill: "url(#paint1_linear_14740_2858)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2388 26.487L13.151 26.6556L7.80224 30.1364L7.71009 30.1969L7.69693 30.2056L7.6706 30.2229H7.66622C5.5776 31.5979 2.7562 31.0444 1.36086 28.9906C-0.0344743 26.9323 0.527171 24.152 2.6114 22.777C2.64212 22.7554 2.67283 22.7381 2.70355 22.7165C2.80447 22.6559 2.90539 22.5954 3.00631 22.5435L3.11601 22.4743L4.38849 21.6657L7.52142 19.668L11.3564 21.4538C14.4411 22.8851 14.4718 24.1088 13.2388 26.487Z",
			fill: "url(#paint2_linear_14740_2858)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_14740_2858",
				x1: 5.54666,
				y1: 10.2244,
				x2: 18.9398,
				y2: 1.22035,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#008D01" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#009C16"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#01DD73"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_14740_2858",
				x1: 30.593,
				y1: 26.7395,
				x2: -10.1229,
				y2: 5.99266,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#008D01" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1126,
						stopColor: "#009C16"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#01DD73"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_14740_2858",
				x1: 15.2131,
				y1: 20.1247,
				x2: -.0941557,
				y2: 30.0895,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#008D01" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .17,
						stopColor: "#00960E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4245,
						stopColor: "#00AE30"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .91,
						stopColor: "#01D467"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#01DD73"
					})
				]
			})
		] })
	]
});
export default SvgLogoSmall;
